import { getLogs } from "api/graphQL_requestlogs";
import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import LogsTable from "./components/LogsList";
import { getAllClients } from "api/clients";

export interface LogsRowObj {
    clientId: string;
    clientName: string;
    customerId: string;
    customerName: string;
    endpoint: string;
    requestData : any;
    responseData : any;
    createdAt:any;
}

const ApiRequestLogs = () => {

    const [page, setPage] = useState<number>(1);
    const [logs, setLogs] = useState<LogsRowObj[]>([]);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData, setSingleRoleData , setFilter, filter } = useContext(ClientContext);
    const location = useLocation();
    const [clients, setClients] = useState();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked,setClearClick] = useState(0)


    
    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = () => {
        setIsLoading(true);
        getAllClients(0)
          .then((data) => {
            setClients(data);
          })
          .catch((err) => {
            toast.error(
              err?.response?.data?.message ??
                "Something went wrong while fetching clients"
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
    };

    const fetchLogs = async () => {
        let finalSearchText = ""
        if(location.state) {
          if (location.state?.search) {
            finalSearchText = location.state.search
            window.history.replaceState({}, document.title);
          }
        } else {
            finalSearchText = searchTexts;
        }
        const client = filter?.client;
        const start_date = filter?.dates?.[0];
        const end_date = filter?.dates?.[1];
        const params = { page: page, per_page: pageSize, searchTexts: finalSearchText, client:client,start_date:start_date,end_date };
        if (pageSize === null || pageSize === undefined) {
          setIsLoading(false);
          return;
        }
        setIsLoading(true);
        
        getLogs(params)
        .then((data:any) => {
            setLogs(data?.[0]);
            setTotalPage(data?.[1].total_pages);
            setTotalItems(data?.[1].total_items);
            setCurrentPage(data?.[1].current_page);
        })
        .catch((err) => {
            setLogs([]);
            setIsLoading(false);
        })
        .finally(() => {
        setIsLoading(false);
        });
    };

    const serchboxValueChange = async (searchTerm: string) => {
        const search_txt = searchTerm || "";
    
        if (search_txt !== searchTexts && searchTexts !== "") {
          await setSearchTexts(search_txt);
          setPage(1);
          setCurrentPage(1);
        } else {
          await setSearchTexts(search_txt);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [page, pageSize, searchTexts,clearClicked]);

    const onClearClick = () => {
        setClearClick((prev) => {
          const newCount = prev + 1;
          return newCount;
        });
    };

    return (
        <>
    
        
        <div className="mt-5">
        <LogsTable
            clients={clients}
            tableData={logs}
            fetchLogs={fetchLogs}
            isLoading={isLoading}
            roleData={singleRoleData}
            onValueChange={serchboxValueChange}
            page={page}
            setPage={setPage}
            totalpage={totalpage}
            totalItems={totalItems}
            currentPage={currentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setLocalFilters={setLocalFilters}
            filterData={fetchLogs}
            localFilters={localFilters}
            filter={filter}
            setFilter={setFilter}
            setClearClick={onClearClick}
        />
        </div>
        </>
    );
};

export default ApiRequestLogs;
